var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMcColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 29,
    viewBox: "0 0 35 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.765 7.94h-7.03V20.58h7.03V7.94z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.181 14.26a8.061 8.061 0 013.058-6.32 7.981 7.981 0 00-4.955-1.72 8.031 8.031 0 00-8.034 8.04 8.031 8.031 0 008.034 8.038 7.982 7.982 0 004.955-1.72 8.029 8.029 0 01-3.058-6.319z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 14.26a8.032 8.032 0 01-8.034 8.038 7.983 7.983 0 01-4.955-1.72 7.995 7.995 0 003.058-6.319A8.061 8.061 0 0017.26 7.94a7.981 7.981 0 014.955-1.72c4.44 0 8.034 3.618 8.034 8.04z",
    fill: "#F79E1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcColor);
export default __webpack_public_path__ + "static/media/MC__color.5d27804f19ea5838c2e21000f63a8717.svg";
export { ForwardRef as ReactComponent };